module.exports = (__webpack_require__(4))(1409);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/symbol-observable/es/index.js from dll-reference vendorProd_library
// module id = 872
// module chunks = 42